export const pipelineFormStyles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        mx: '143.5px',
    },
    fieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        mt: 2,
        width: '100%',
    },
};
